import React from "react";
import config from "../../../config";
import { CreateHvSubstationPayload, HvSubstation2Submission, HvSubstationSubmission } from "../interfaces/HvSubstation";
import { ApiHandlerPureComponent } from "./ApiHandlerPureComponent";
import {
  ExistingSurveyableAsset,
  Panel,
  PanelsSubmission,
  PanelSubmission,
  SurveyableAssetSubmission,
  mapHvSurveyableAssetFromAsset,
  PanelMapping,
} from "../interfaces/SurveyableAsset";

interface Props {
  onAuthError?: () => void;
}

export default class HvSubstationAPIs extends React.PureComponent<Props> {
  private apiResponseHandler = new ApiHandlerPureComponent({
    onAuthError: this.props.onAuthError,
  });

  private static readonly BASE_URL: string = `${config.apiGateway.META_API}/api/HvSubstations/`;

  async createHvSubstation(substationSubmission: HvSubstation2Submission): Promise<any> {
    const apiAddress = `${HvSubstationAPIs.BASE_URL}`;
    const payload = CreateHvSubstationPayload(substationSubmission);
    const payloadString = JSON.stringify(payload);
    return await this.apiResponseHandler.post(apiAddress, payloadString);
  }

  updateHvSubstation = async (hvSubstationSubmission: HvSubstationSubmission): Promise<any> => {
    var apiAddress = `${HvSubstationAPIs.BASE_URL}`;
    return this.apiResponseHandler.put(apiAddress, JSON.stringify(hvSubstationSubmission.hvSubstation), false);
  };

  deleteHvSubstation = async (hvSubstationId: number): Promise<any> => {
    var apiAddress = `${HvSubstationAPIs.BASE_URL}substationId/${hvSubstationId}`;
    return this.apiResponseHandler.delete(apiAddress, false);
  };

  addSurveyableAssetToExistingHvSubstation = async (
    surveyableAssetSubmission: SurveyableAssetSubmission,
  ): Promise<any> => {
    const transformedAssets = surveyableAssetSubmission.surveyableAsset.map(mapHvSurveyableAssetFromAsset);
    const apiAddress = `${HvSubstationAPIs.BASE_URL}HVSurveyableAsset/HVSubstation/${surveyableAssetSubmission.hvSubstationId}`;
    return this.apiResponseHandler.post(apiAddress, JSON.stringify(transformedAssets), false);
  };

  updateHvSurveyableAsset = async (surveyableAsset: ExistingSurveyableAsset): Promise<any> => {
    var apiAddress = `${HvSubstationAPIs.BASE_URL}HvSurveyableAsset/${surveyableAsset.id}`;
    return this.apiResponseHandler.put(apiAddress, JSON.stringify(surveyableAsset), false);
  };

  deleteHvSurveyableAsset = async (surveyableAssetId: number): Promise<any> => {
    var apiAddress = `${HvSubstationAPIs.BASE_URL}HvSurveyableAsset/${surveyableAssetId}`;
    return this.apiResponseHandler.delete(apiAddress, false);
  };

  addHvSurveyableChildAssetsToExistingSurveyableAsset = async (panelSubmission: PanelsSubmission): Promise<any> => {
    var apiAddress = `${HvSubstationAPIs.BASE_URL}HvSurveyableChildAsset/${panelSubmission.surveyableAssetId}`;
    return this.apiResponseHandler.post(apiAddress, JSON.stringify(panelSubmission.panels), false);
  };

  updateHvSurveyableChildAsset = async (panel: Panel): Promise<any> => {
    var apiAddress = `${HvSubstationAPIs.BASE_URL}HvSurveyableChildAsset/${panel.panelAssetId}`;
    return this.apiResponseHandler.put(apiAddress, JSON.stringify(panel), false);
  };

  updateHvSurveyableChildAssetNumber = async (panel: PanelSubmission): Promise<any> => {
    var apiAddress = `${HvSubstationAPIs.BASE_URL}HvSurveyableChildAsset/${panel.panel.panelAssetId}/number/${panel.panel.panelNo}`;
    return this.apiResponseHandler.patch(apiAddress, JSON.stringify(panel), false);
  };

  updateHvSurveyableChildAssetName = async (panel: PanelSubmission): Promise<any> => {
    var apiAddress = `${HvSubstationAPIs.BASE_URL}HvSurveyableChildAsset/${panel.panel.panelAssetId}/name/${panel.panel.name}`;
    return this.apiResponseHandler.patch(apiAddress, JSON.stringify(panel), false);
  };

  deleteHvSurveyableChildAsset = async (panelId: number): Promise<any> => {
    var apiAddress = `${HvSubstationAPIs.BASE_URL}HvSurveyableChildAsset/${panelId}`;
    return this.apiResponseHandler.delete(apiAddress, false);
  };

  getChildMappingsByAssetIds = async (assetIds: number[]): Promise<PanelMapping[]> => {
    if (!assetIds || assetIds.length === 0) {
      return [];
    }
    const queryString = assetIds.map((id) => `parentIds=${id}`).join("&");
    const apiAddress = `${HvSubstationAPIs.BASE_URL}SurveyableAssetPanelMappings?${queryString}`;

    return this.apiResponseHandler.get(apiAddress).then((data) => {
      if (!data || !Array.isArray(data)) {
        return [];
      }
      return data;
    });
  };
}
